// @flow

import type {BiePluginType} from '../types';
import {CanvasManager} from '../managers/canvas-manager';

export class BieDrawPlugin implements BiePluginType {
  objectsCount: number;

  setup() {}

  getActionButtons() {
    return [
      {
        type: 'enter-state',
        title: 'Draw',
        icon: 'fas fa-pencil-alt',
        slug: 'pencil',
        component: 'div',
        enter: this.start,
        cancel: this.cancel,
        confirm: this.confirm,
        triggerEvent: this.handleEvent,
        eventButtons: [
          {
            type: 'colorPalette',
          },
        ],
      },
    ];
  }

  handleEvent = (cm: CanvasManager, event: any) => {
    cm.canvas.freeDrawingBrush.color = event.type;
  };

  cancel(cm: CanvasManager) {
    cm.canvas.isDrawingMode = false;

    cm.canvas
      .getObjects()
      .slice(this.objectsCount)
      .map((object) => cm.canvas.remove(object));
    cm.canvas.renderAll();
  }

  confirm(cm: CanvasManager) {
    cm.canvas.isDrawingMode = false;
    cm.saveState();
  }

  start(cm: CanvasManager) {
    cm.canvas.isDrawingMode = true;
    cm.canvas.freeDrawingBrush.width = 10;
    cm.canvas.freeDrawingBrush.color = 'red';

    this.objectsCount = cm.canvas.getObjects().length;
  }
}
